<div class="form-box">
  <knust-data-table newButtonText="Neue Entnahme-Notiz erstellen"
                    (entityRowClick)="openTrunkNoticeDialog($event)"
                    (addEntityClick)="openTrunkNoticeDialog()"
                    (deleteEntityClick)="deleteTrunkNotice($event)"
                    [commandMap]="commandMap"
                    [columnConfig]="columnConfig"
                    [displayedColumns]="displayedColumns">
  </knust-data-table>
</div>
